/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { ChannelInfoChannelFragment, ChannelInfoChannelCrossPointFragment } from './channel-info-channel.generated';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ChannelInfoDeviceFragment = {
	id: string;
	compatibility: Types.CompatibilityLevel;
	status: Types.DeviceStatus;
	virtual: boolean;
	isDeviceNode: 'Device';
	description: {
		model: string;
		features: {
			logicMute: { supported: boolean };
			audioChannels: { supported: boolean };
			danteAudioNetworkAccess: { supported: boolean };
			meteringModes: { supported: boolean };
			license: { supported: boolean };
			stereoAudio: { supported: boolean };
			conferencingOperationMode: { supported: boolean };
			rfDensityMode: { supported: boolean };
			analogAudioOutputMode: { supported: boolean };
			allIntellimixBypass: { supported: boolean };
			dectRfSpectrumScan: { supported: boolean };
			transmitterMuteBehavior: { supported: boolean };
			usbConnection: { supported: boolean };
		};
		constraints: {
			conferencingOperationMode: { mode: { options: Array<Types.ConferencingOperationMode> } } | null;
			analogAudioOutputMode: { mode: { options: Array<Types.AnalogAudioOutputMode> } | null } | null;
		};
	};
	features: {
		audioChannelCount: { count: number } | null;
		license: {
			info: Array<{
				state: Types.LicenseState;
				inUse: boolean | null;
				inGrace: boolean | null;
				inWarning: boolean | null;
				graceExpiresIn: string | null;
				type: Types.LicenseType | null;
			}>;
		} | null;
		logicMute: { muted: boolean } | null;
		audioChannels: { audioChannels: Array<ChannelInfoChannelFragment> } | null;
		authentication: {
			credentials: Array<{ accessLevel: string; credentialsState: Types.CredentialsState }> | null;
		} | null;
		danteAudioNetworkAccess: { changesAllowed: boolean; factoryResetAllowed: boolean } | null;
		meteringModes: { inputMode: Types.MeteringMode; outputMode: Types.MeteringMode } | null;
		firmware: { valid: boolean; version: string } | null;
		stereoAudio: { enabled: boolean } | null;
		conferencingOperationMode: { mode: Types.ConferencingOperationMode } | null;
		rfDensityMode: { mode: Types.RfDensityMode } | null;
		analogAudioOutputMode: { mode: Types.AnalogAudioOutputMode } | null;
		allIntellimixBypass: { bypassed: boolean } | null;
		dectRfSpectrumScan: { inProgress: boolean } | null;
		transmitterMuteBehavior: {
			usbHostDisconnectMuteBehavior: Types.TransmitterUsbHostDisconnectMuteBehavior;
			muteBehavior: Types.TransmitterMuteBehavior;
		} | null;
		usbConnection: { status: Types.UsbConnection } | null;
	};
};

export type ChannelInfoDeviceUpdateFragment = {
	id: string;
	features:
		| { allIntellimixBypass: { bypassed: boolean } | null }
		| { analogAudioOutputMode: { mode: Types.AnalogAudioOutputMode } | null }
		| { audioChannelCount: { count: number } | null }
		| { audioChannels: { audioChannels: Array<ChannelInfoChannelFragment> } | null }
		| {
				authentication: {
					credentials: Array<{ accessLevel: string; credentialsState: Types.CredentialsState }> | null;
				} | null;
		  }
		| { conferencingOperationMode: { mode: Types.ConferencingOperationMode } | null }
		| { danteAudioNetworkAccess: { changesAllowed: boolean; factoryResetAllowed: boolean } | null }
		| { dectRfSpectrumScan: { inProgress: boolean } | null }
		| {
				license: {
					info: Array<{
						state: Types.LicenseState;
						inUse: boolean | null;
						inGrace: boolean | null;
						graceExpiresIn: string | null;
						type: Types.LicenseType | null;
					}>;
				} | null;
		  }
		| { logicMute: { muted: boolean } | null }
		| { meteringModes: { inputMode: Types.MeteringMode; outputMode: Types.MeteringMode } | null }
		| { rfDensityMode: { mode: Types.RfDensityMode } | null }
		| { stereoAudio: { enabled: boolean } | null }
		| {
				transmitterMuteBehavior: {
					usbHostDisconnectMuteBehavior: Types.TransmitterUsbHostDisconnectMuteBehavior;
					muteBehavior: Types.TransmitterMuteBehavior;
				} | null;
		  }
		| { usbConnection: { status: Types.UsbConnection } | null }
		| {};
};

export type ChannelInfoDeviceMatrixMixerFragment = {
	id: string;
	isDeviceNode: 'Device';
	description: { features: { audioChannels: { supported: boolean } } };
	features: {
		audioChannels: {
			audioChannels: Array<{
				id: string;
				features: { matrixMixerOutput: { crossPoints: Array<ChannelInfoChannelCrossPointFragment> } | null };
			}>;
		} | null;
	};
};

export type GetDeviceQueryVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
}>;

export type GetDeviceQueryOpResult = { node: ChannelInfoDeviceFragment | {} };

export type GetDeviceMatrixMixerQueryVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
}>;

export type GetDeviceMatrixMixerQueryOpResult = { node: ChannelInfoDeviceMatrixMixerFragment | {} };

export type UpdateDeviceMutationVariables = Types.Exact<{
	updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type UpdateDeviceMutationOpResult = {
	updateNodes: Array<{ error: { code: Types.ErrorCode; message: string } | null } | {}>;
};

export type DeviceSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type DeviceSubscriptionOpResult = { nodeChanges: ChannelInfoDeviceUpdateFragment | {} };

export const ChannelInfoDeviceFragment = gql`
	fragment ChannelInfoDeviceFragment on Device {
		isDeviceNode: __typename
		id
		compatibility
		status
		virtual
		description {
			model
			features {
				logicMute {
					supported
				}
				audioChannels {
					supported
				}
				danteAudioNetworkAccess {
					supported
				}
				meteringModes {
					supported
				}
				license {
					supported
				}
				stereoAudio {
					supported
				}
				conferencingOperationMode {
					supported
				}
				rfDensityMode {
					supported
				}
				analogAudioOutputMode {
					supported
				}
				allIntellimixBypass {
					supported
				}
				dectRfSpectrumScan {
					supported
				}
				transmitterMuteBehavior {
					supported
				}
				usbConnection {
					supported
				}
			}
			constraints {
				conferencingOperationMode {
					mode {
						options
					}
				}
				analogAudioOutputMode {
					mode {
						options
					}
				}
			}
		}
		features {
			audioChannelCount {
				count
			}
			license {
				info {
					state
					inUse
					inGrace
					inWarning
					graceExpiresIn
					type
				}
			}
			logicMute {
				muted
			}
			audioChannels {
				audioChannels {
					... on AudioChannel {
						...ChannelInfoChannelFragment
					}
				}
			}
			authentication {
				credentials {
					accessLevel
					credentialsState
				}
			}
			danteAudioNetworkAccess {
				changesAllowed
				factoryResetAllowed
			}
			meteringModes {
				inputMode
				outputMode
			}
			firmware {
				valid
				version
			}
			stereoAudio {
				enabled
			}
			conferencingOperationMode {
				mode
			}
			rfDensityMode {
				mode
			}
			analogAudioOutputMode {
				mode
			}
			allIntellimixBypass {
				bypassed
			}
			dectRfSpectrumScan {
				inProgress
			}
			transmitterMuteBehavior {
				usbHostDisconnectMuteBehavior
				muteBehavior
			}
			usbConnection {
				status
			}
		}
	}
	${ChannelInfoChannelFragment}
`;
export const ChannelInfoDeviceUpdateFragment = gql`
	fragment ChannelInfoDeviceUpdateFragment on DeviceChange {
		id
		features {
			... on DeviceAudioChannelsChange {
				audioChannels {
					audioChannels {
						...ChannelInfoChannelFragment
					}
				}
			}
			... on DeviceAudioChannelCountChange {
				audioChannelCount {
					count
				}
			}
			... on DeviceLicenseChange {
				license {
					info {
						state
						inUse
						inGrace
						graceExpiresIn
						type
					}
				}
			}
			... on DeviceLogicMuteChange {
				logicMute {
					muted
				}
			}
			... on DeviceAuthenticationChange {
				authentication {
					credentials {
						accessLevel
						credentialsState
					}
				}
			}
			... on DeviceDanteAudioNetworkAccessChange {
				danteAudioNetworkAccess {
					changesAllowed
					factoryResetAllowed
				}
			}
			... on DeviceMeteringModesChange {
				meteringModes {
					inputMode
					outputMode
				}
			}
			... on DeviceStereoAudioChange {
				stereoAudio {
					enabled
				}
			}
			... on DeviceConferencingOperationModeChange {
				conferencingOperationMode {
					mode
				}
			}
			... on DeviceRfDensityModeChange {
				rfDensityMode {
					mode
				}
			}
			... on DeviceAnalogAudioOutputModeChange {
				analogAudioOutputMode {
					mode
				}
			}
			... on DeviceAllIntellimixBypassChange {
				allIntellimixBypass {
					bypassed
				}
			}
			... on DeviceDectRfSpectrumScanChange {
				dectRfSpectrumScan {
					inProgress
				}
			}
			... on DeviceTransmitterMuteBehaviorChange {
				transmitterMuteBehavior {
					usbHostDisconnectMuteBehavior
					muteBehavior
				}
			}
			... on DeviceUsbConnectionChange {
				usbConnection {
					status
				}
			}
		}
	}
	${ChannelInfoChannelFragment}
`;
export const ChannelInfoDeviceMatrixMixerFragment = gql`
	fragment ChannelInfoDeviceMatrixMixerFragment on Device {
		isDeviceNode: __typename
		id
		description {
			features {
				audioChannels {
					supported
				}
			}
		}
		features {
			audioChannels {
				audioChannels {
					... on AudioChannel {
						id
						features {
							matrixMixerOutput {
								crossPoints {
									...ChannelInfoChannelCrossPointFragment
								}
							}
						}
					}
				}
			}
		}
	}
	${ChannelInfoChannelCrossPointFragment}
`;
export const GetDeviceQueryDocument = gql`
	query GetDeviceQuery($id: ID!) {
		node(id: $id) {
			...ChannelInfoDeviceFragment
		}
	}
	${ChannelInfoDeviceFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class GetDeviceQueryGQL extends Apollo.Query<GetDeviceQueryOpResult, GetDeviceQueryVariables> {
	override document = GetDeviceQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const GetDeviceMatrixMixerQueryDocument = gql`
	query GetDeviceMatrixMixerQuery($id: ID!) {
		node(id: $id) {
			...ChannelInfoDeviceMatrixMixerFragment
		}
	}
	${ChannelInfoDeviceMatrixMixerFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class GetDeviceMatrixMixerQueryGQL extends Apollo.Query<
	GetDeviceMatrixMixerQueryOpResult,
	GetDeviceMatrixMixerQueryVariables
> {
	override document = GetDeviceMatrixMixerQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const UpdateDeviceMutationDocument = gql`
	mutation UpdateDeviceMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
		updateNodes(updates: $updates, keyring: $injectKeyring) {
			... on DeviceOperationResult {
				error {
					code
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class UpdateDeviceMutationGQL extends Apollo.Mutation<
	UpdateDeviceMutationOpResult,
	UpdateDeviceMutationVariables
> {
	override document = UpdateDeviceMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const DeviceSubscriptionDocument = gql`
	subscription DeviceSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			...ChannelInfoDeviceUpdateFragment
		}
	}
	${ChannelInfoDeviceUpdateFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class DeviceSubscriptionGQL extends Apollo.Subscription<
	DeviceSubscriptionOpResult,
	DeviceSubscriptionVariables
> {
	override document = DeviceSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
